module.exports = __webpack_public_path__ + "static/img/hzyguidetext@3x.8a2d54e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hzyguidetext@3x.png
// module id = wK5i
// module chunks = 1